<ng-container *ngIf="item.isShown">
    <!-- item.url -->
    <a
        class="nav-link"
        [ngClass]="item.classes"
        *ngIf="item.url && !item.externalUrl && !item.function"
        (click)="onNavigationClick(item.url)"
        [routerLink]="[item.url]"
        [routerLinkActive]="['active', 'mat-accent-bg']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
        [target]="item.openInNewTab ? '_blank' : '_self'"
        matRipple
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl -->
    <a
        class="nav-link"
        [ngClass]="item.classes"
        *ngIf="item.url && item.externalUrl && !item.function"
        [href]="item.url"
        [target]="item.openInNewTab ? '_blank' : '_self'"
        matRipple
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.function -->
    <span
        class="nav-link"
        [ngClass]="item.classes"
        *ngIf="!item.url && item.function"
        (click)="item.function()"
        matRipple
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>

    <!-- item.url && item.function -->
    <a
        class="nav-link"
        [ngClass]="item.classes"
        *ngIf="item.url && !item.externalUrl && item.function"
        (click)="item.function()"
        [routerLink]="[item.url]"
        [routerLinkActive]="['active', 'mat-accent-bg']"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
        [target]="item.openInNewTab ? '_blank' : '_self'"
        matRipple
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl && item.function -->
    <a
        class="nav-link"
        [ngClass]="item.classes"
        *ngIf="item.url && item.externalUrl && item.function"
        (click)="item.function()"
        [href]="item.url"
        [target]="item.openInNewTab ? '_blank' : '_self'"
        matRipple
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <ng-template #itemContent>
        <ng-container *ngIf="showOverlayBadge; else expandedMode">
            <p-overlaybadge
                *ngIf="item.badge; else noBadge"
                [value]="item.badge.translate"
                styleClass="nav-overlaybadge"
            >
                <ng-container *ngTemplateOutlet="noBadge"></ng-container>
            </p-overlaybadge>
        </ng-container>
        <ng-template #expandedMode>
            <ng-container *ngTemplateOutlet="noBadge"></ng-container>
        </ng-template>

        <ng-template #noBadge>
            <mat-icon
                class="nav-link-icon"
                *ngIf="item.icon && item.iconType === 'material' && item.iconTooltip"
                matTooltip="{{ item.translate | translate }}"
                >{{ item.icon }}</mat-icon
            >
            <mat-icon class="nav-link-icon" *ngIf="item.icon && item.iconType === 'material' && !item.iconTooltip">
                {{ item.icon }}</mat-icon
            >
            <img
                class="nav-link-icon"
                [src]="item.icon"
                *ngIf="item.icon && item.iconType === 'svg' && item.iconTooltip"
                matTooltip="{{ item.translate | translate }}"
                [attr.alt]="item.title"
            />
            <img
                class="nav-link-icon"
                [src]="item.icon"
                *ngIf="item.icon && item.iconType === 'svg' && !item.iconTooltip"
                [attr.alt]="item.title"
            />
            <span
                class="nav-link-icon {{ item.icon }}"
                *ngIf="item.icon && item.iconType !== 'material' && item.iconType !== 'svg' && item.iconTooltip"
                matTooltip="{{ item.translate | translate }}"
            ></span>
            <span
                class="nav-link-icon {{ item.icon }}"
                *ngIf="item.icon && item.iconType !== 'material' && item.iconType !== 'svg' && !item.iconTooltip"
            ></span>
        </ng-template>
        <span class="nav-link-title">{{ item.translate | translate }}</span>
        <span
            class="nav-link-badge"
            *ngIf="!showOverlayBadge && item.badge"
            [ngStyle]="{ 'background-color': item.badge.bg, 'color': item.badge.fg }"
        >
            {{ item.badge.translate | translate }}
        </span>
    </ng-template>
</ng-container>
